module.exports = __webpack_public_path__ + "img/circle_red.9dd1a01a.png";